module.exports = __webpack_public_path__ + "static/hyperv_18.42c8befa.jpg";